/* BEDROCK interactions retained and scoped to the HEMATIX product template. */
(() => {
  if (window.hbSectionsReady) return;
  window.hbSectionsReady = true;
  const behavior = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  function initialize(scope) {
    scope.querySelectorAll('[data-hb-below]:not([data-hb-ready])').forEach(root => {
      root.dataset.hbReady = '';
      const listeners = new AbortController();
      root.hbCleanup = () => listeners.abort();
      const on = (element, name, fn, options = {}) => element?.addEventListener(name, fn, { ...options, signal: listeners.signal });
      const marquee = root.querySelector('[data-hb-marquee]');
      const pause = marquee?.querySelector('[data-hb-marquee-pause]');
      on(pause, 'click', () => {
        const paused = marquee.classList.toggle('is-paused');
        pause.setAttribute('aria-pressed', String(paused));
        pause.textContent = paused ? 'Play' : 'Pause';
      });
      root.querySelectorAll('[data-hb-tabs]').forEach(widget => {
        const timeline = widget.dataset.hbTabs === 'timeline';
        const tabs = [...widget.querySelectorAll(timeline ? '[data-tl-tab]' : '[data-pt-tab]')];
        const panels = [...widget.querySelectorAll(timeline ? '[data-tl-desc]' : '[data-pt-panel]')];
        const slides = timeline ? [...widget.querySelectorAll('[data-tl-slide]')] : [];
        const activate = index => {
          tabs.forEach((tab, i) => {
            tab.classList.toggle('is-active', i === index);
            tab.setAttribute('aria-selected', String(i === index));
            tab.tabIndex = i === index ? 0 : -1;
          });
          [...panels, ...slides].forEach((panel, i) => {
            const active = i % panels.length === index;
            // Keep both panels rendered so the original opacity/visibility fades run.
            panel.removeAttribute('hidden');
            panel.setAttribute('aria-hidden', String(!active));
            panel.toggleAttribute('inert', !active);
            panel.classList.toggle('is-active', active);
          });
        };
        if (tabs.length) activate(Math.max(0, tabs.findIndex(tab => tab.classList.contains('is-active'))));
        tabs.forEach((tab, index) => {
          on(tab, 'click', () => activate(index));
          on(tab, 'keydown', event => {
            const next = { ArrowRight: (index + 1) % tabs.length, ArrowLeft: (index - 1 + tabs.length) % tabs.length, Home: 0, End: tabs.length - 1 }[event.key];
            if (next === undefined) return;
            event.preventDefault(); activate(next); tabs[next].focus();
          });
        });
        on(widget, 'shopify:block:select', event => {
          const panel = event.target.closest(timeline ? '[data-tl-desc]' : '[data-pt-panel]');
          if (panel) activate(panels.indexOf(panel));
        });
      });
      const reviewViewport = root.querySelector('[data-rr-viewport]');
      const prev = root.querySelector('[data-rr-prev]');
      const next = root.querySelector('[data-rr-next]');
      if (reviewViewport) {
        const cards = [...reviewViewport.querySelectorAll('.rr-card')];
        const step = () => (cards[0]?.offsetWidth || 380) + (parseFloat(getComputedStyle(reviewViewport.querySelector('.rr-track')).columnGap) || 0);
        const refresh = () => {
          const max = reviewViewport.scrollWidth - reviewViewport.clientWidth - 2;
          if (prev) prev.disabled = reviewViewport.scrollLeft <= 2;
          if (next) next.disabled = reviewViewport.scrollLeft >= max;
        };
        const move = direction => reviewViewport.scrollBy({ left: direction * step(), behavior: behavior() });
        on(prev, 'click', () => move(-1)); on(next, 'click', () => move(1));
        on(reviewViewport, 'keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1);
        });
        let ticking = false;
        on(reviewViewport, 'scroll', () => {
          if (ticking) return;
          ticking = true; requestAnimationFrame(() => { refresh(); ticking = false; });
        }, { passive: true });
        on(window, 'resize', refresh); refresh();
      }
      const viewport = root.querySelector('[data-sc-viewport]');
      const dotsWrap = root.querySelector('[data-sc-dots]');
      if (viewport && dotsWrap) {
        const pages = [...viewport.querySelectorAll('.sc-page')];
        const centerOf = page => page.offsetLeft - viewport.offsetLeft - (viewport.clientWidth - page.offsetWidth) / 2;
        dotsWrap.replaceChildren();
        pages.forEach((page, index) => {
          const button = document.createElement('button');
          button.type = 'button'; button.className = 'sc-dot' + (index === 0 ? ' is-active' : '');
          button.setAttribute('aria-label', `Product facts page ${index + 1}`);
          button.setAttribute('aria-current', String(index === 0));
          on(button, 'click', () => viewport.scrollTo({ left: centerOf(page), behavior: behavior() }));
          dotsWrap.appendChild(button);
        });
        const dots = [...dotsWrap.children];
        const refresh = () => {
          const center = viewport.scrollLeft + viewport.clientWidth / 2;
          let closest = 0; let distance = Infinity;
          pages.forEach((page, index) => {
            const delta = Math.abs(page.offsetLeft - viewport.offsetLeft + page.offsetWidth / 2 - center);
            if (delta < distance) { distance = delta; closest = index; }
          });
          dots.forEach((dot, index) => { dot.classList.toggle('is-active', index === closest); dot.setAttribute('aria-current', String(index === closest)); });
        };
        let ticking = false;
        on(viewport, 'scroll', () => {
          if (ticking) return;
          ticking = true; requestAnimationFrame(() => { refresh(); ticking = false; });
        }, { passive: true });
        on(window, 'resize', refresh);
      }
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-hb-below]').forEach(root => root.hbCleanup?.()));
})();
